import usStates from './united-states';
import caStates from './canada';
import auStates from './australia';
import mxStates from './mexico';
import nzStates from './newZealand';
import coStates from './colombia';

export default {
  ca: caStates || [],
  us: usStates || [],
  au: auStates || [],
  mx: mxStates || [],
  nz: nzStates || [],
  co: coStates || [],
};
